export default __webpack_public_path__ + "static/media/koala.11060ed3.png";